import { render } from "./DanceView.vue?vue&type=template&id=97c2551a"
import script from "./DanceView.vue?vue&type=script&lang=js"
export * from "./DanceView.vue?vue&type=script&lang=js"

import "./DanceView.vue?vue&type=style&index=0&id=97c2551a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__